/**
 *
 * @param obj
 * @param parentKey
 * Turn {a: {b: 1}} to {"a.b": 1}
 */
export const flattenObject = (o, pKey?) => {
  return Object.keys(o).reduce((acc, k) => {
    const mk = `${pKey ? pKey + '.' : ''}${k}`
    const value = o[k]
    return typeof value === 'object' && value !== null
      ? { ...acc, ...flattenObject(value, mk) }
      : { ...acc, [mk]: value }
  }, {})
}

/**
 *
 * @param obj
 * Remove keys that are null
 * Turn {a: 1, b: null} to {a: 1}
 */
export const compactObject = (obj) =>
  Object.entries(obj).reduce((acc, [k, v]) => {
    return v === null ? { ...acc } : { ...acc, [k]: v }
  }, {})

/**
 *
 * @param obj
 * @param parentKey
 * Turn {"a.b.c": 2, "b.c": 5} to {a: {b: {c: 2}}, b: {c: 5}}
 */

export const deFlattenObject = (obj, acc?, parentKeyIndex?) => {
  const toReturn = acc || {}
  Object.keys(obj).forEach((k) => {
    let key = k.split('.')
    if (parentKeyIndex) {
      key = key.slice(parentKeyIndex, obj.length)
    }
    if (key.length === 1) {
      toReturn[key[0]] = obj[k]
    } else {
      const childAcc = toReturn[key[0]]
      toReturn[key[0]] = deFlattenObject({ [k]: obj[k] }, childAcc, (parentKeyIndex || 0) + 1)
    }
  })
  return toReturn
}
